import { render, staticRenderFns } from "./ProductCategoryUpdate.vue?vue&type=template&id=72a30004&scoped=true"
import script from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"
export * from "./ProductCategoryUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a30004",
  null
  
)

export default component.exports